<app-page-header>Complete your order</app-page-header>

<app-summary-header-container
  [selected]="productDetailsService.selected$ | async"
  [costSummary]="completeOrderService.costSummary$ | async"
  [upfrontPaymentSummary]="completeOrderService.upfrontPayment$ | async"
  [offers]="viewOffersService.offers$ | async"
  [offerError]="itemOfferError$ | async"
  [previousUrl]="previousUrl$ | async"
></app-summary-header-container>
<app-order-form
  [form]="form"
  [currentPlan]="currentPlan$ | async"
  [activeStep]="activeStep$ | async"
  [isProtectionSelected]="
    additionalServicesService.isProtectionSelected$ | async
  "
  [offers]="viewOffersService.offers$ | async"
  [selected]="productDetailsService.selected$ | async"
  [upfrontPaymentSummary]="completeOrderService.upfrontPayment$ | async"
></app-order-form>
